import { Box } from '@mui/material'
import CardTable from 'components/CardTable/CardTable'
import { TableInputs } from 'components/CardTable/TableInputs'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import { columns } from './columns'
import { PurchasesLicenseInput } from './PurchasesLicenseInput'
import {
  getCRE_Licenses,
  getPurchases,
  setPurchasesFilters,
} from 'redux/actions/purchases/purchasesAction';
import dayjs from 'dayjs';
import { useSearch } from 'hooks/useSearch';
import { dateValidator } from 'helpers/dateValidator';
import { newDate } from 'helpers/dateTools';

const tableKey = "purchases";

export const Purchases = () => {
  const dispatch = useDispatch();

  const { buildTableConfig, setSnackbar, clearSearch } = useSearch();

  //selectors
  const { token } = useSelector(state => state.login);
  const {
    startDate,
    endDate,
    creLicenseSelected,
    purchases,
  } = useSelector(state => state.purchases)
  const { isLoading, configTables } = useSelector((state) => state.search);

  //localState
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
    if (!creLicenseSelected) {
      setSnackbar("No se ha seleccionado alguna licencia.");
      return;
    }
    const start = dayjs(startDate).format("YYYY-MM-DD");
    const end = dayjs(endDate).format("YYYY-MM-DD");

    dispatch(getPurchases(token, creLicenseSelected.value, start, end));
    setSubmitted(true);
  }, [startDate, endDate, creLicenseSelected, token]);

  useEffect(() => {
    dispatch(getCRE_Licenses());
    clearSearch();
  }, [])

  useEffect(() => {
    !configTables[tableKey] && buildTableConfig(tableKey);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const isEmpty = purchases.length === 0
    if (isEmpty && submitted) {
      setSnackbar("No se encontraron compras en ese rango de fechas");
    }
    setSubmitted(false);
    // eslint-disable-next-line
  }, [purchases])

  return (
    <Box>
      <CardTable
        data={purchases}
        columns={columns}
        hasHeader
        blockBtn
        title="Compras"
        icon={<ShoppingCartIcon />}
        isLoading={isLoading}
        tableKey={tableKey}
        tableContent={
          <TableInputs
            reducer="purchases"
            dates
            maxDate={newDate()}
            dispatchAction={setPurchasesFilters}
            submitAction={handleSubmit}
            loading={isLoading}
          >
            <PurchasesLicenseInput />
          </TableInputs>
        }
      />
    </Box>
  )
}
